import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Card from '../Card/Card';
import './Cards.css';
import LoadingBar from '../LoadingBar/LoadingBar';

function Cards({ apiClubData }) {

  const [clubBusinessListData, setClubBusinessListData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const getData = async () => {
      try {
          const [ clubBusinessListResponse] = await Promise.all([axios.get(apiClubData.clubBusinessMember)]);

          const clubBusinessList = clubBusinessListResponse.data;

          // Process business data and associate benefits
          const processedClubBusinessData = clubBusinessList.map( cbm => {

          // Convert address to array if it's a string
          const address = cbm.businessPublicInformation?.address;
          const addressArray = Array.isArray(address)
            ? address
            : typeof address === 'string' && address
              ? [address]
              : [];

          return {
              id: cbm.id,
              name: cbm.businessPublicInformation.name,
              address: addressArray,
              description: cbm.businessPublicInformation.description || '',
              smallLogoUrl: cbm.businessPublicInformation.picture_url || '',
              benefitsOfferList: cbm.benefitOfferList || []
          };
        });

        setClubBusinessListData(processedClubBusinessData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };

    getData();
  }, []);


  return (
    <div className='Business-Cards'>
      {loading && <LoadingBar text="עסקים" />}
      {clubBusinessListData.map((clubBusinessData) => (
        <Card key={clubBusinessData.id} data={clubBusinessData} />
      ))}
    </div>
  );
}

export default Cards;